import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { B as Button } from "./Button.js";
import { I as Icon } from "./Icon.js";
import ChevronDown from "./components/Icons/ChevronDown.js";
import ChevronUp from "./components/Icons/ChevronUp.js";
import tableStyles from "./components/Table/styles.module.scss";
import { M as ModeType } from "./Table.js";
const TableExpanderCell = ({
  expandableRowId,
  hideDetailsText,
  showDetailsText,
  expanded,
  className,
  mode = ModeType.normal
}) => {
  const tableCellClass = classNames(tableStyles["table__cell"], tableStyles["table__cell-expander"], className, {
    [tableStyles["table__cell--compact"]]: mode === ModeType.compact
  });
  const icon = expanded ? ChevronUp : ChevronDown;
  return /* @__PURE__ */ jsx("td", { className: tableCellClass, children: /* @__PURE__ */ jsx(
    Button,
    {
      variant: "borderless",
      "aria-expanded": expanded,
      "aria-controls": expandableRowId,
      ariaLabel: expanded ? hideDetailsText : showDetailsText,
      children: /* @__PURE__ */ jsx(Icon, { svgIcon: icon })
    }
  ) });
};
export {
  TableExpanderCell as T
};
//# sourceMappingURL=TableExpanderCell.js.map
